module.exports = __webpack_public_path__ + "static/OP11-66180f5749f608f066801d9a5704e170.png";